import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function MobilePayment2(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "MobilePayment2",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx("path", { d: "M35.2008 9.30009h-22.4V38.7001h22.4V9.30009Z", fill: theme.vars.palette.secondary.main }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M32.4008 3.7h-16.8c-1.54 0-2.8 1.26-2.8 2.8v2.8h22.4V6.5c0-1.54-1.26-2.8-2.8-2.8Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M25.4004 7.20009h-2.8c-.42 0-.7-.28-.7-.7 0-.42.28-.7.7-.7h2.8c.42 0 .7.28.7.7 0 .42-.28.7-.7.7Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M32.4008 44.3h-16.8c-1.54 0-2.8-1.26-2.8-2.8v-2.8h22.4v2.8c0 1.54-1.26 2.8-2.8 2.8Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M25.4004 42.2001h-2.8c-.42 0-.7-.28-.7-.7 0-.42.28-.7.7-.7h2.8c.42 0 .7.28.7.7 0 .42-.28.7-.7.7Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M28.9 35.9h-9.8c-1.19 0-2.1-.91-2.1-2.1s.91-2.1 2.1-2.1h9.8c1.19 0 2.1.91 2.1 2.1s-.91 2.1-2.1 2.1Zm7.7-7H11.4c-.77 0-1.4-.63-1.4-1.4v-14c0-.77.63-1.4 1.4-1.4h25.2c.77 0 1.4.63 1.4 1.4v14c0 .77-.63 1.4-1.4 1.4Z",
            fill: theme.vars.palette.secondary.dark
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M38 16.2999H10v4.2h28v-4.2Z", fill: theme.vars.palette.primary.light }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.0008 26.7997c-.42 0-.7-.28-.7-.7v-2.1c0-.42.28-.7.7-.7.42 0 .7.28.7.7v2.1c0 .42-.28.7-.7.7Zm2.8 0c-.42 0-.7-.28-.7-.7v-2.1c0-.42.28-.7.7-.7.42 0 .7.28.7.7v2.1c0 .42-.28.7-.7.7Zm1.4 0c-.42 0-.7-.28-.7-.7v-2.1c0-.42.28-.7.7-.7.42 0 .7.28.7.7v2.1c0 .42-.28.7-.7.7Zm2.1 0c-.42 0-.7-.28-.7-.7v-2.1c0-.42.28-.7.7-.7.42 0 .7.28.7.7v2.1c0 .42-.28.7-.7.7Zm1.4 0c-.42 0-.7-.28-.7-.7v-2.1c0-.42.28-.7.7-.7.42 0 .7.28.7.7v2.1c0 .42-.28.7-.7.7Zm2.8 0c-.42 0-.7-.28-.7-.7v-2.1c0-.42.28-.7.7-.7.42 0 .7.28.7.7v2.1c0 .42-.28.7-.7.7Z",
            fill: theme.vars.palette.primary.dark
          }
        )
      ]
    }
  );
}
MobilePayment2.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "MobilePayment2"
};
validateTidalLicense();
export {
  MobilePayment2
};
//# sourceMappingURL=MobilePayment2.js.map
